import type { Components, Theme } from "@mui/material/styles";

export const MuiStep: NonNullable<Components<Theme>["MuiStep"]> = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingLeft: 0,
      paddingRight: 0,
      [theme.breakpoints.up("md")]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    }),
  },
};
